import httpClient from "../../configs/http-client";
import apiUrl from "../../constants/apiUrl";
import { IAds, EngageAction, ValidateOUPayment, AdsDetail, CustomerSubcampaignStatus, MultiCoupons, SubcampaignCouponDetail, CreateEGC, SubmitRedeemSelfService, CreatePayGetCoupon } from "./ads.interface";

export const getAds = async ({ type = "earn", offset = 0, limit = 10, orderBy, defaultCountry, language_code, subcampaign_id }: IAds) => {
  return httpClient.get(
    apiUrl.LIST_SUB_CAMPAIGN,
    {
      params: {
        type: type,
        offset,
        limit,
        order_by: orderBy,
        default_country: defaultCountry,
        language_code: language_code?.replace("-", "_"),
        subcampaign_id: subcampaign_id
      }
    }
  ).then((res) => res.data);
};

export const getMultiCoupons = async ({ offset = 0, limit = 10, orderBy, defaultCountry, language_code, engage_session_id }: MultiCoupons) => {
  return httpClient.get(
    apiUrl.MULTI_COUPONS,
    {
      params: {
        offset,
        limit,
        order_by: orderBy,
        default_country: defaultCountry,
        language_code: language_code?.replace("-", "_"),
        engage_session_id: engage_session_id
      }
    }
  ).then((res) => res.data);
};

export const getAdsDetail = async ({ id, type, customer_subcampaign_id = 0, engage_id, isRewardPage }: AdsDetail) => {
  const params = new URLSearchParams();
  if (type && type !== "null") {
    params.append("type", type);
  }
  if (customer_subcampaign_id) {
    params.append("customer_subcampaign_id", customer_subcampaign_id.toString());
  }
  if (engage_id) {
    params.append("engage_session_id", engage_id);
  }
  if (isRewardPage) {
    params.append("is_reward_page", String(isRewardPage));
  }
  const url = `${apiUrl.SUB_CAMPAIGN_DETAIL}${id}${params.toString() ? `?${params.toString()}` : ""}`;
  return httpClient.get(url).then((res) => res.data);
};

export const getSubcampaignCouponDetail = async ({ id, customer_subcampaign_id = 0, engage_id, coupon_session }: SubcampaignCouponDetail) => {
  const params = new URLSearchParams();
  if (customer_subcampaign_id) {
    params.append("customer_subcampaign_id", customer_subcampaign_id.toString());
  }
  if (engage_id) {
    params.append("engage_session_id", engage_id);
  }
  if (coupon_session) {
    params.append("coupon_session_id", coupon_session);
  }
  const url = `${apiUrl.SUB_CAMPAIGN_COUPON_DETAIL}${id}${params.toString() ? `?${params.toString()}` : ""}`;
  return httpClient.get(url).then((res) => res.data);
};


export const getCouponDetail = async ({ id }: { id: string }) => {
  return httpClient.get(apiUrl.COUPON_DETAIL + id).then((res) => res.data);
};

export const getCustomerSubcampaignStatus = async ({ id, is_use_page = false, customer_subcampaign_id = 0, engage_id }: CustomerSubcampaignStatus) => {
  let url = apiUrl.CUSTOMER_SUBCAMPAIGN_STATUS + id + `?is_use_page=${is_use_page}`;
  if (engage_id) {
    url += `&engage_session_id=${engage_id}`;
  } else if (customer_subcampaign_id) {
    url += `&customer_subcampaign_id=${customer_subcampaign_id}`;
  }
  return httpClient.get(url).then((res) => res.data);
};


export const getUserInfo = async ({ subcampaign_id }: { subcampaign_id: string }) => {
  const url = apiUrl.GET_USER_INFO + subcampaign_id;
  return httpClient.get(url).then((res) => res.data);
};


export const getSubCampaignRegister = async (
  { id, qrSession }: { id: string | null, qrSession?: string }
) => {
  return httpClient.get(
    apiUrl.SUB_CAMPAIGN_REGISTER + id,
    { params: qrSession ? { qr_session: qrSession } : {} }
  ).then((res) => res.data);
};

export const getSubcampaignByChannel = async ({
  channelId,
  qrSession,
  utmSource,
  utmMedium,
  utmContent,
  utmCampaign,
}: {
  channelId: string;
  qrSession?: string;
  utmSource?: string;
  utmMedium?: string;
  utmContent?: string;
  utmCampaign?: string;
}) => {
  return httpClient
    .get(apiUrl.SUBCAMPAIGN_BY_CHANNEL + channelId, {
      params: {
        qr_session: qrSession,
        utm_source: utmSource,
        utm_medium: utmMedium,
        utm_content: utmContent,
         utm_campaign: utmCampaign,
      },
    })
    .then((res) => res.data);
};

export const getEngage = async (b64_encoded_data: string) => {
  return httpClient.get(
    apiUrl.SEND_COUPON + b64_encoded_data,
  ).then((res) => res.status);
};

export const postEngageAction = async (
  {
    subcampaign_id,
    qrscanlog_id,
    isCouponPage,
    isEngagePage,
    isVerifyPage,
    engage_session,
    isFromContinueBtn,
    channelSessionId,
    isReload,
  }: EngageAction) => {
  const payload = {
    subcampaign_id: subcampaign_id,
    is_coupon_page: isCouponPage,
    is_engage_page: isEngagePage,
    is_verify_page: isVerifyPage,
    ...(qrscanlog_id && { qrscanlog_id: qrscanlog_id }),
    ...(engage_session && { "engage-session": engage_session }),
    ...(isFromContinueBtn && { "is_from_continue_btn": true }),
    ...(channelSessionId && { "channel_session_id": channelSessionId }),
    ...(isReload && { "is_page_reload": isReload })

  };
  return httpClient.post(apiUrl.ENGAGE_ACTION, payload).then((res) => res);
};

export const postEngageDAGC = (subcampaign_id: String) => httpClient.post(
  apiUrl.ENGAGE_DAGC,
  { subcampaign_id }
);

export const pullDAGCQualificationStatus = (dagc_session_id: String, last_pull_request: Boolean = false) => httpClient.post(
  apiUrl.PULL_DAGC_QUALIFICATION_STATUS,
  {
    dagc_session_id,
    last_pull_request,
  }
);

export const validateOuPayment = async ({ merchant_reference, subCampaignId }: ValidateOUPayment) => {
  return httpClient.get(
    apiUrl.VALIDATE_OU_PAYMENT,
    {
      params: {
        merchant_reference: merchant_reference,
        subcampaign_id: subCampaignId
      }
    }
  ).then((res) => res.status);
};

export const validateEngageSession = async (session_id: String) => {
  return httpClient.get(
    apiUrl.VALIDATE_ENGAGE_SESSION + session_id,
  ).then((res) => res.data);
};

export const engageGetCredit = async ({ subcampaign_id, qr_session, customer_session, channelSessionId }: CreateEGC) => {
  return httpClient.post(
    apiUrl.CREATE_ENGAGE_GET_CREDIT,
    { subcampaign_id, qr_session, customer_session, "channel_session_id": channelSessionId }
  );
};

export const validateEngageFirst = async (engage_session: String) => {
  return httpClient.post(
    apiUrl.VALIDATE_ENGAGE_FIRST,
    { "engage-session": engage_session }
  );
};

export const issueCoupon = async ({
  subcampaign_id,
  engage_session,
  isNonVendingPayGetCoupon,
  merchantReference
}:
  { subcampaign_id?: Number, engage_session?: String, isNonVendingPayGetCoupon?: boolean, merchantReference?: string }) => {
  return httpClient.post(
    apiUrl.ISSUE_COUPON,
    {
      subcampaign_id,
      "engage-session": engage_session,
      "is_non_vending_pay_get_coupon": isNonVendingPayGetCoupon,
      "merchant_reference": merchantReference
    }
  );
};

export const redeemSelfService = async ({ engageSession, ouCode, couponCode }: SubmitRedeemSelfService) => {
  return httpClient.post(
    apiUrl.REDEEM_SELF_SERVICE_COUPON,
    { "coupon_code": couponCode, "engage_session": engageSession, "ou_code": ouCode }
  );
};

export const validateCampaignEngagedLimit = async (
  { id }: { id: number }
) => {
  return httpClient.get(apiUrl.VALIDATE_CAMPAIGN_ENGAGED_LIMIT + id)
    .then((res) => res.status);
};

export const sendReceiptEmail = async (
  { receipt_id, email }: { receipt_id: string, email: string }
) => {
  return httpClient.post(apiUrl.SEND_RECEIPT_EMAIL, { receipt_id, email })
    .then((res) => res.status);
};

export const loyaltySubmit = async ({ memberId, engageSessionId }: { memberId: string, engageSessionId: string }) => {
  return httpClient.post(apiUrl.LOYALTY_SUBMIT, { "member_id": memberId, "engage_session_id": engageSessionId })
    .then((res) => res.status);
};

export const getListPage = async (id: number) => httpClient
  .get(apiUrl.GET_LIST_PAGE.replace(":id", String(id)));

export const updatePaypayConsent = async ({ couponSession }: { couponSession: string }) => {
  return httpClient.put(apiUrl.UPDATE_PAYPAY_CONSENT, { "coupon_session": couponSession });
};

export const createPayGetCoupon = async ({
  subcampaignId,
  productPrice,
  qrscanlogId,
  channelSessionId,
  engageSessionId,
  session_id
}: CreatePayGetCoupon) => {
  return httpClient.post(apiUrl.CREATE_PAY_GET_COUPON, {
    "subcampaign_id": subcampaignId,
    "product_price": productPrice,
    "qrscanlog_id": qrscanlogId,
    "channel_session_id": channelSessionId,
    "engage_session_id": engageSessionId,
    "session_id": session_id
  });
};
